import { render } from "./CornseedIcon.vue?vue&type=template&id=5977b54c&scoped=true"
import script from "./CornseedIcon.vue?vue&type=script&lang=js"
export * from "./CornseedIcon.vue?vue&type=script&lang=js"

import "./CornseedIcon.vue?vue&type=style&index=0&id=5977b54c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5977b54c"]])

export default __exports__